// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { CallCardDispatch_abstract } from '@models/imported/abstract/SagaSchema/CallCardDispatch_abstract';

export class CallCardDispatch extends CallCardDispatch_abstract {
  rShort(): string {
    return 'FE: ' + this.Identifier;
  }
}
